import axios from "axios";
import { handlerError } from "utils";
import { notification } from "antd";
import moment from "moment";

export const saveUser = async (id = null, user) => {
  try {
    delete user.companyExternal;
    if (user.birthday)
      user.birthday = moment(user.birthday).format("yyyy-MM-DD");
    if(user.legalRepresentative?.birthday)
      user.legalRepresentative.birthday = moment(user.legalRepresentative.birthday).format("yyyy-MM-DD");

    const req = {
      data: {
        ...user,
        password: id
          ? user.password
          : Math.random().toString(36).slice(-8) + "#"
      }
    };
    let res = null;
    if (id) {
      res = await axios.put(`/user/${id}`, req);
    } else {
      res = await axios.post(`/user`, req);
    }
    if (res.data && res.data.success) {
      id = res.data.data.id;
      // if (user.sendEmail || user.sendSms) {
      //     await savePasswordUser(id, user.sendEmail, user.sendSms);
      // } else if (user.password && user.confirmation) {
      //     await savePasswordUser(id, false, false, user.password, user.confirmation);
      // }
      notification.success({
        message: "Participante salvo com sucesso"
      });
    }
    return res.data;
  } catch (ex) {
    handlerError(ex);
    throw ex;
  }
};

export const disableUser = async (id = null, disable) => {
  try {

    const req = {
      disable: disable
    };
    let res = null;
    if (id) {
      res = await axios.put(`/user/${id}/disable`, req);
    } else {
      notification.error({
        message: "Participante deve estar cadastrado no sistema"
      });
    }
    if (res.data && res.data.success) {
      notification.success({
        message: `Participante ${disable? "excluido": "habilitado"} com sucesso`
      });
    }
    return { success: true };
  } catch (ex) {
    handlerError(ex);
    return { success: false };
  }
};

export const saveUserBatch = async (user) => {
  try {
    if (user.birthday) {
      user.birthday = moment(user.birthday).format("yyyy-MM-DD");
    }
    const {matriz,canManageMatriz,manageMatriz,...reqUser} = user
    let req = { data: { ...reqUser } };
    const { data } = await axios.put(`/user/${user.id}/batch`, req);
    return data;
  } catch (ex) {
    handlerError(ex);
    return {
      success: false,
      errorMessage:
        ex.data && ex.data.errorMessage ? ex.data.errorMessage : null,
      infos: ex.data && ex.data.infos ? ex.data.infos : null
    };
  }
};

export const savePreRegisterUserBatch = async ({userID = 0, user}) => {
  try {
    let req = { data: user };
    const { data } = await axios.put(`/user/${userID}/batch/pre-register`, req);
    return data;
  } catch (ex) {
    return {
      success: false,
      errorMessage: ex.data && ex.data.errorMessage ? ex.data.errorMessage : null,
      infos: ex.data && ex.data.infos ? ex.data.infos : null
    };
  }
};

export const savePreRegisterBusinessBatch = async ({userID = 0, user}) => {
  try {
    let req = { data: user };
    const { data } = await axios.put(`/user/${userID}/batch/pre-register/business`, req);
    return data;
  } catch (ex) {
    return {
      success: false,
      errorMessage: ex.data && ex.data.errorMessage ? ex.data.errorMessage : null,
      infos: ex.data && ex.data.infos ? ex.data.infos : null
    };
  }
};

export const deletePreRegisterUserBatch = async (userID) => {
  try {
    const { data } = await axios.delete(`/user/${userID}/batch/pre-register`);
    return data;
  } catch (ex) {
    return {
      success: false,
      errorMessage: ex.data && ex.data.errorMessage ? ex.data.errorMessage : null,
      infos: ex.data && ex.data.infos ? ex.data.infos : null
    };
  }
};

export const sendFirstAccessNotification = async (userID) => {
	try {
		const { data } = await axios.get(`/user/${userID}/first-access-notification`);
		return data;
	} catch (ex) {
		return {
			success: false,
			errorMessage: ex.data && ex.data.errorMessage ? ex.data.errorMessage : null,
			infos: ex.data && ex.data.infos ? ex.data.infos : null
		};
	}
};

export const userRedeem = async (user, type, benefit, amount = 0) => {
  try {
    const { data } = await axios.post(`/solicitation/redeem`, {
      user: user,
      type: type,
      toBenefit: benefit,
      amount: amount,
    });
    return data;
  } catch (ex) {
    handlerError(ex);
    return {};
  }
};

export const savePasswordUser = async (
  id = null,
  sendEmail = false,
  sendSms = false,
  password = null,
  confirmation = null,
  link = false
) => {
  try {
    const req = {
      data: {
        sendEmail: sendEmail,
        sendSms: sendSms,
        link: link
      }
    };
    let ret;
    if (password && confirmation) {
      req.data.password = password;
      req.data.confirmation = confirmation;
      ret = await axios.put(`/user/${id}/password`, req);
    } else {
      ret = await axios.post(`/user/${id}/password`, req);
    }

    return ret.data;
  } catch (ex) {
    handlerError(ex);
    throw null;
  }
};

export const getAllUsers = async ({ type, filter,getChildrenCompanies = false, page = 1, pageSize = 10 } = {}) => {
  try {
    const params = type || filter || getChildrenCompanies ? { type: type, filter: filter, getChildrenCompanies:getChildrenCompanies, page: page, pageSize: pageSize } : {page:page, pageSize: pageSize};
    const { data } = await axios.get(`/user`, { params: params });
    return data;
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const search = async (query) => {
  try {
    const params = { query: query };
    const { data } = await axios.get(`/user/search`, { params: params });
    return data && data.users ? data.users : [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getUserBalance = async (user) => {
  try {
    const { data } = await axios.get(`/employee/balance?user=${user}`, {});
    return data ? data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getCorporateBalance = async (user) => {
  try {
    const { data } = await axios.get(`/employee/balance/corporate?user=${user}`);
    return data ? data : null;
  } catch (ex) {
    return null;
  }
};

export const getUserStatement = async (id) => {
  try {
    const { data } = await axios.get(`/employee/balance?user=${id}`, {});
    return data ? data : 0;
  } catch (ex) {
    return 0;
  }
};

export const getUserBalanceId = async (user) => {
  try {
    const { data } = await axios.get(`/user/${user}/balance`, {});
    return data || null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getByIdUser = async (id) => {
  try {
    const { data } = await axios.get(`/user/${id}`);
    return data.data ? data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getCurrentUser = async (id) => {
  try {
    const { data } = await axios.get(`/user/current`);
    return data.data ? data.data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getStatement = async (user, page) => {
  try {
    const { data } = await axios.get(
      page !== null
        ? `/employee/statement?user=${user}&page=${page}`
        : `/employee/statement?user=${user}&complete=true`,
      {}
    );
    return data.transactions ? data.transactions : [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getCorporateStatement = async (user, page) => {
  try {
    const { data } = await axios.get(
      page !== null
        ? `/employee/statement/corporate?user=${user}&page=${page}`
        : `/employee/statement/corporate?user=${user}&complete=true`
    );
    return data.transactions ?? [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getUserStatementByFilter = async ({companyID, filter = null, dates = null, page = 1, pageSize = 10, listAll = false, sorter = null, types = null, benefits = null, status = false}) => {
  try {
    const { data } = await axios.get(`/employee/statements/${companyID}`, {
      params: {
        ...(filter ? { filter: filter.trim() } : {}),
        ...(dates ? { dates: dates } : {}),
        page: page,
        size: pageSize,
        listAll,
        ...(sorter ? { sorter: sorter } : {}),
        ...(types ? { types: types } : {}),
        ...(benefits ? { benefits: benefits } : {}),
        ...(status ? { status: status } : {}),
      }
    });
    return data;
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getAllOccupation = async () => {
  try {
    const { data } = await axios.get(`/user/occupations`);
    return data && data.data ? data.data : [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getAllOccupationV2 = async () => {
  try {
    const { data } = await axios.get(`/user/v2/occupations`);
    return data && data.occupations ? data.occupations : [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getUserKycStatus = async (user) => {
  try {
    const { data } = await axios.get(`/user/${user}/kycStatus`);
    return data ? data.data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getBiometricUserUrls = async (user) => {
  try {
    const data  = await axios.put(`/employee/${user}/biometric/url`, {});
    return data ? data.data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getBiometricUserUrlsByToken = async (token) => {
  try {
    const data  = await axios.put(`/employee/biometric/url/${token}`, {});
    return data ? data.data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const sendBiometricUrlEmail = async (user) => {
  try {
    const data  = await axios.post(`/employee/${user}/biometric/send`, {});
    return data ? data.data : null;
  } catch (ex) {
    handlerError(ex);
    return null;
  }
};

export const getChargesUser = async (user) => {
  try {
    const { data } = await axios.get(`/user/${user}/solicitations`);
    return data && data.entries ? data.entries : [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getNewUserCompany = async (user, newCompany, type) => {
  try {
    const { data } = await axios.get(
      `/user/${user}/newCompany?company=${newCompany}&type=${type}`
    );
    return data ? data : null;
  } catch (ex) {
    handlerError(ex);
    return ex.data ? ex.data : null;
  }
};

export const saveNewCompanyUser = async (user, companyID) => {
  try {
    const { data } = await axios.put(`/user/${user}/newCompany`, {company: companyID});
    notification.success({
      message: "Participante salvo com sucesso!"
    });
    return data;
  } catch (ex) {
    handlerError(ex);
    return { swapCompany: false };
  }
};

export const saveCardManager = async (company, managers = []) => {
  try {
    await axios.post(`/user/card/manager`, {
      company: company,
      managers: managers.map((x) => {
        return {
          manager: x.id,
          managerBranch: x.cardManagerBranch
        };
      })
    });
    notification.success({
      message: "Gerentes atualizados com sucesso"
    });
  } catch (ex) {
    handlerError(ex);
  }
};

export const saveRegisterManager = async (company, managers = []) => {
  try {
    await axios.post(`/user/register/manager`, {
      company: company,
      managers: managers.map((x) => {
        return {
          manager: x.id,
          managerBranch: x.registerBranchManager
        };
      })
    });
    notification.success({
      message: "Gerentes atualizados com sucesso"
    });
  } catch (ex) {
    handlerError(ex);
  }
};

export const getCompaniesUsers = async (user) => {
  try {
    const { data } = await axios.get(`/user/${user}/companies`);
    return data && data.history ? data.history : [];
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const saveRefresh = async (id) => {
  try {
    await axios.post(`/user/${id}/refresh`);
  } catch (ex) {
    handlerError(ex);
    throw null;
  }
};

export const saveUserManagerMatriz = async (id, enabled = false) => {
  try {
    const req = {
      enabled
    };
    await axios.put(`/user/${id}/manager`, req);
    notification.success({ message: "Salvo com sucesso" });
  } catch (ex) {
    handlerError(ex);
    throw ex;
  }
};
